export default {
    'bond-no': 'Número de bono',
    add: 'Añadir',
    delete: 'Eliminar',
    'bond-date': 'Fecha de bono',
    'create-bond': 'Añadir producto',
    edit: 'Editar',
    save: 'Guardar',

    not: 'No',
    posted: 'Publicado',

    'total-costs': 'Coste total',
    'create-manufacturing-bond': 'Añadir bono de fabricación',
    'manufacturing-bond-date': 'Fechas de bono de fabricación',
    
    create: 'Crear',
    cancel: 'Cancelar',

    'delete-entry': 'Eliminar asiento contable',
    'are-you-sure-you-want-to-delete-the-entry': '¿estas seguro de eliminar el asiento?',

    'delete-journal': 'Eliminar diario',
    'are-you-sure-you-want-to-delete-the-journal': '¿estas seguro de eliminar el diario?',

    'context-menu': {
        'show-details': 'Mostrar detalles',
        edit: 'Editar',
        delete: 'Eliminar',
    },

    headers: {
        'no': 'Número',
        'warehouse': 'Almacén',
        'material-name': 'Nombre de materia',
        'count': 'Número',
        'produced-quantity': 'Cantidad producida',
        'unit': 'Medida',
        'loss-ratio': 'Porcentaje de deterioro',
        'cost-of-one': 'Costo por unidad',
        'total-cost': 'Costo total',
    }
}